module.exports = __webpack_public_path__ + "img/brand.3c1b12b3.png";